<div class="outstanding-conditions-card">
  <a class="outstanding-conditions-card__link"
     [routerLink]="['/tpo/app-details/' + appId + '/conditions']">
    <span class="outstanding-conditions-card__label">
      Outstanding {{ isTpoSubmitted ? 'Conditions' : 'Tasks' }}
    </span>
    <b class="outstanding-conditions-card__count"
       [class.outstanding-conditions-card__count--alert]="hasOutstanding">
      {{ outstandingConditionsCount }}
    </b>
  </a>
</div>
